import React, { useState } from 'react';
import InventoryOperationsPage from './InventoryOperationsPage';
import { Col, Nav, NavItem, Row, Tab } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import PharmacyOperationsPage from './PharmacyOperationsPage';
import PharmacyItemsPage from './PharmacyItemsPage';
import { useAuthorization } from '../../../components/Authorization/useAuthorization';
import LaboratoryKitItemsPage from './LaboratoryKitItemsPage';
import ProtocolItemsPage from './ProtocolItemsPage';
import InventoryReportLog from './InventoryReportLog';
import { usePendingSuccessNotice } from '../../../components/Notifications/usePendingSuccessNotice';
import { useHistory } from "react-router-dom";
import { InventoryTab, inventoryTabTarget, resolveInventoryTab } from './inventoryTabNavigation';

const keys = InventoryTab

export function InventoryManagment({ match }) {
    const [activeTab, setActiveTab] = React.useState(resolveInventoryTab(match?.params?.section))
    const { t } = useTranslation();
    const history = useHistory();
    const [, , isAuthorized] = useAuthorization();
    usePendingSuccessNotice();

    const handleSelectTab = (key) => {
        setActiveTab(key)
        history.replace(inventoryTabTarget(key))
    }

    return <>
        <Tab.Container id="inventory-managment" activeKey={activeTab} onSelect={handleSelectTab} >
            <Row className="clearfix">
                <Col sm={12}>
                    <Nav bsStyle="tabs" >
                        <NavItem eventKey={keys.operations} >{t('inventory.commons.operations')}</NavItem>
                        {
                            isAuthorized(["GeneralInventory.Edit"]) && <NavItem eventKey={keys.pharmacyInventory}>{t('inventory.commons.pharmacy')}</NavItem>
                        }
                        {
                            isAuthorized(["ProtocolInventory.View", "ProtocolInventory.Edit"]) && <NavItem eventKey={keys.protocolInventory}>{t('inventory.commons.protocol')}</NavItem>
                        }
                        {
                            isAuthorized(["LaboratoryKitInventory.Edit"]) && <NavItem eventKey={keys.laboratoryKitInventory}>{t('inventory.commons.laboratoryKit')}</NavItem>
                        }
                        {
                            isAuthorized(["GeneralInventory.Edit"]) && <NavItem eventKey={keys.pharmacy}>{t('inventory.dispense.pharmacyDispenseTitle')}</NavItem>
                        }
                        {
                            isAuthorized(["GeneralInventory.Create", "ProtocolInventory.Create"]) && <NavItem eventKey={keys.inventoryReportLog}>{t('inventory.reports.intentoryLogs')}</NavItem>
                        }
                    </Nav>

                </Col>
                <Col sm={12}>
                    <Tab.Content>
                        <Tab.Pane eventKey={keys.operations}>
                            {activeTab == keys.operations && <InventoryOperationsPage />}
                        </Tab.Pane>
                        <Tab.Pane eventKey={keys.pharmacyInventory}>
                            {activeTab == keys.pharmacyInventory && <PharmacyItemsPage />}
                        </Tab.Pane>
                        <Tab.Pane eventKey={keys.protocolInventory}>
                            {activeTab == keys.protocolInventory && <ProtocolItemsPage />}
                        </Tab.Pane>
                        <Tab.Pane eventKey={keys.laboratoryKitInventory}>
                            {activeTab == keys.laboratoryKitInventory && <LaboratoryKitItemsPage />}
                        </Tab.Pane>
                        <Tab.Pane eventKey={keys.pharmacy}>
                            {activeTab == keys.pharmacy && <PharmacyOperationsPage />}
                        </Tab.Pane>
                        <Tab.Pane eventKey={keys.inventoryReportLog}>
                            {activeTab == keys.inventoryReportLog && <InventoryReportLog />}
                        </Tab.Pane>
                    </Tab.Content>
                </Col>
            </Row>
        </Tab.Container>
    </>
}
